import { useTranslation } from "react-i18next";
import { Layout } from "@/components/layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Building2,
  FileText,
  Wrench,
  Package,
  ShoppingCart,
} from "lucide-react";
import { useLocation } from "wouter";

export default function AdminPage() {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();

  return (
    <Layout headerContent={<span className="font-semibold">{t("common.admin")}</span>}>
      <div className="space-y-6">
        <div className="mb-4">
          <p className="text-muted-foreground">
            {t("pages.admin.manageSystemSettingsAnd")}
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          <Card
            className="cursor-pointer hover:bg-accent/50 transition-colors"
            onClick={() => setLocation("/admin/company-profile")}
          >
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Building2 className="h-5 w-5" />
                {t("pages.admin.companyProfileLabel2")}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {t("pages.admin.seeAndEditYour")}
              </p>
            </CardContent>
          </Card>

          <Card
            className="cursor-pointer hover:bg-accent/50 transition-colors"
            onClick={() => setLocation("/admin/quote-templates")}
          >
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5" />
                {t("pages.admin.quoteTemplatesLabel2")}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {t("pages.admin.defineCommonJobTypes")}
              </p>
            </CardContent>
          </Card>

          <Card
            className="cursor-pointer hover:bg-accent/50 transition-colors"
            onClick={() => setLocation("/admin/services")}
          >
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Wrench className="h-5 w-5" />
                {t("common.services")}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {t("pages.admin.manageServiceOfferingsAnd")}
              </p>
            </CardContent>
          </Card>

          <Card
            className="cursor-pointer hover:bg-accent/50 transition-colors"
            onClick={() => setLocation("/admin/custom-parts")}
          >
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Package className="h-5 w-5" />
                {t("pages.admin.customPartsLabel2")}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {t("pages.admin.manageCustomPartsAnd")}
              </p>
            </CardContent>
          </Card>

          <Card
            className="cursor-pointer hover:bg-accent/50 transition-colors"
            onClick={() => setLocation("/admin/order-templates")}
          >
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <ShoppingCart className="h-5 w-5" />
                {t("pages.admin.orderTemplatesLabel2")}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {t("pages.admin.manageOrderTemplatesFor")}
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}
